import axiosUrl from './axios.service';
import axios from 'axios';
import store from '../store/index';
import authHeader from '../helpers/auth-header';
import moment from 'moment';
import router from '../router/index';
import UserService from './userprofile.service';
import AuthService from '../services/auth.service';
import { computed } from 'vue';
const API_URL = axiosUrl.getAxiosUrl();

const currentPage = computed({
  get: () => store.state.advancedSearch.currentPage,
});

class GrantsService {
  async loadDefaultSchemes() {
    return await axios
      .get(API_URL + '/search/searchschemes', {
        headers: authHeader(),
        params: {
          PageSize: 10,
          Page: currentPage.value - 1,
          Statusses: 'Open,Forthcoming,',
          Sort: 'Relevantie',
        },
      })
      .then((response) => {
        /*         store.commit('advancedSearch/updateCurrentPage', 1);
         */ store.commit('grantItems/updateGrants', response.data);
        store.commit(
          'advancedSearch/updatePageCount',
          response.data.pageCount + 1
        );
        store.commit(
          'advancedSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('grantItems/disableSearchPageLoading');
        store.commit('advancedSearch/disableFiltersChange');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async downloadDocument(documentId) {
    return await axios
      .get(API_URL + `/scheme/download?documentId=${documentId}`, {
        headers: authHeader(),
        responseType: 'blob',
        reportProgress: true,
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
        if (error)
          store.commit('scheme/updateModalError', error.response),
            store.commit('scheme/enableModalError');
      });
  }

  async getSearchResults(
    searchText,
    statusBoxes,
    audiences,
    locations,
    //This is just hidden for now, don't remove it:
    //industries,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsIncludeString,
    orgsExcludeString,
    startDate,
    endDate,
    sort
  ) {
    return await axios
      .get(API_URL + '/search/searchschemes', {
        headers: authHeader(),
        params: {
          Term: searchText.value,
          PageSize: 10,
          Page: currentPage.value - 1,
          Sort: sort.value,
          Statusses: statusBoxes.value,
          AudienceTags: audiences.value,
          //This is just hidden for now, don't remove it
          // IndustriesTags: industries.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags: locations.value,
          AppliesToSME: smeString.value,
          ApplicationTerms: applicationTermsString.value,
          MinAmount: minBudget.value,
          MaxAmount: maxBudget.value,
          Scopes: scopesString.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          CallStartDate:
            startDate.value != null && startDate.value != ''
              ? moment(startDate.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          CallEndDate:
            endDate.value != null && endDate.value != ''
              ? moment(endDate.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
        },
      })
      .then((response) => {
        store.commit('grantItems/updateGrants', response.data);
        store.commit(
          'advancedSearch/updatePageCount',
          response.data.pageCount + 1
        );
        store.commit(
          'advancedSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('advancedSearch/updateMaxScoreOnCurrentPage');
        store.commit('advancedSearch/updateMaxScore', response.data.topScore);
        store.commit('user/setIsProfileSearch', false);
        store.commit('advancedSearch/disableFiltersChange');
        store.commit('grantItems/disableSearchPageLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async getResulstsByPage(
    current,
    searchText,
    statusBoxes,
    audiences,
    locations,
    //This is just hidden for now, don't remove it:
    //industries,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsIncludeString,
    orgsExcludeString,
    startDate,
    endDate,
    sort
  ) {
    return await axios

      .get(API_URL + '/search/searchschemes', {
        headers: authHeader(),
        params: {
          Term: searchText.value,
          PageSize: 10,
          Page: current,
          Sort: sort.value,
          Statusses: statusBoxes.value,
          AudienceTags: audiences.value,
          //This is just hidden for now, don't remove it
          // IndustriesTags: industries.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags: locations.value,
          AppliesToSME: smeString.value,
          ApplicationTerms: applicationTermsString.value,
          MinAmount: minBudget.value,
          MaxAmount: maxBudget.value,
          Scopes: scopesString.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          CallStartDate:
            startDate.value != null && startDate.value != ''
              ? moment(startDate.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
          CallEndDate:
            endDate.value != null && endDate.value != ''
              ? moment(endDate.value, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,
        },
      })
      .then((response) => {
        store.commit('grantItems/updateGrants', response.data);
        store.commit(
          'advancedSearch/updatePageCount',
          response.data.pageCount + 1
        );
        store.commit(
          'advancedSearch/updateResultsCount',
          response.data.resultCount
        );
        store.commit('advancedSearch/disableFiltersChange');
        store.commit('grantItems/disableSearchPageLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async getSchemeById(id, includeChildren) {
    var urlParams = new URLSearchParams(window.location.search);
    return await axios
      .get(API_URL + '/scheme/getScheme', {
        params: {
          schemeId: id,
          terms: urlParams.get('t'),
          includeChildren: includeChildren,
        },
        headers: authHeader(),
      })
      .then((response) => {
        store.commit('grantItems/updateSelectedGrant', response.data);
        store.commit('grantItems/disableGrantDetailsLoading');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async saveSearch(savedSearch, schemeSearchFilters) {
    return await axios
      .post(
        API_URL + `/search/saveSchemesSearch`,
        {
          title: savedSearch.title,
          isSchemesFilter: true,
          folderId: savedSearch.folder != null ? savedSearch.folder.id : null,
          folderName:
            savedSearch.folder == null || savedSearch.folder.id == 0
              ? savedSearch.newFolderName
              : savedSearch.folder.name,
          filter: {
            term: schemeSearchFilters.searchText,
            pageSize: 10,
            page: 0,
            appliesToSME: schemeSearchFilters.smeTypes,
            scopes: schemeSearchFilters.scopesString,
            applicationTerms: schemeSearchFilters.termsString,
            statusses: schemeSearchFilters.statuses,
            callStartDate:
              schemeSearchFilters.startDate != null &&
              schemeSearchFilters.startDate != ''
                ? moment(schemeSearchFilters.startDate, 'DD-MM-YYYY').format(
                    'YYYY-MM-DD'
                  )
                : null,
            callEndDate:
              schemeSearchFilters.endDate != null &&
              schemeSearchFilters.endDate != ''
                ? moment(schemeSearchFilters.endDate, 'DD-MM-YYYY').format(
                    'YYYY-MM-DD'
                  )
                : null,
            audienceTags: schemeSearchFilters.audienceTags,
            purposesTags: schemeSearchFilters.purposesTags,
            //This is just hidden for now, don't remove it:
            //industriesTags: schemeSearchFilters.industriesTags,
            locationsTags: schemeSearchFilters.locationsTags,
            schemeTypesTags: schemeSearchFilters.schemeTypesTags,
            projectTypesTags: schemeSearchFilters.projectTypesTags,
            organisations: schemeSearchFilters.organisationsInclude,
            notOrganisations: schemeSearchFilters.organisationsExclude,
            minAmount: schemeSearchFilters.minBudget,
            maxAmount: schemeSearchFilters.maxBudget,
          },
        },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        if (res.status === 200) {
          store.commit('user/disableSave');
          store.commit('user/enableShowSavedSearchInfoDialog', res.data);
          //router.push({ name: 'UserProfile', params: { tab: 'savedItems' } });
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
        if (error)
          store.commit('user/updateModalError', error.response.data),
            store.commit('user/enableModalError');
      });
  }

  async removeSavedSearch(searchId, folderId) {
    return await axios
      .post(
        API_URL + `/search/removeSchemesSearch`,
        {
          id: searchId,
          isSchemesFilter: true,
          folderId: folderId,
        },
        {
          headers: authHeader(),
        }
      )
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
        if (error)
          store.commit('user/updateModalError', error.response.data),
            store.commit('user/enableModalError');
      });
  }

  async hideScheme(schemeId) {
    return axios({
      method: 'post',
      url: API_URL + `/scheme/hideScheme`,
      headers: authHeader(),
      params: {
        schemeId: schemeId,
      },
    })
      .then((response) => {
        if (response.status == 200)
          store.commit('user/enableShowHiddenInfoDialog');
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
        if (error)
          store.commit('scheme/updateModalError', error.response.data),
            store.commit('scheme/enableModalError');
      });
  }

  async unhideScheme(schemeId) {
    return axios({
      method: 'post',
      url: API_URL + `/scheme/unhideScheme`,
      headers: authHeader(),
      params: {
        schemeId: schemeId,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          UserService.getHiddenSchemes();
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
        if (error)
          store.commit('scheme/updateModalError', error.response.data),
            store.commit('scheme/enableModalError');
      });
  }

  async searchNewestSchemes(page, size) {
    return await axios
      .get(API_URL + '/search/searchschemes', {
        headers: authHeader(),
        params: {
          PageSize: size,
          Page: page,
          Sort: 'Datum',
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit('homePageItems/updateGrantsNewest', response.data);
        } else {
          store.commit('homePageItems/updateGrantsNewest', response.data);

          store.commit('grantItems/updateNewestGrants', response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async searchNewestSchemesTags(page, size, audiences, purposes, locations) {
    return await axios
      .get(API_URL + '/search/searchschemes', {
        headers: authHeader(),
        params: {
          PageSize: size,
          Page: page,
          Sort: 'Datum',
          /*  AudienceTags: audiences.value.length > 0 ? audiences.value : null,
          PurposesTags: purposes.value.length > 0 ? purposes.value : null,
          LocationsTags: locations.value.length > 0 ? locations.value : null, */
          AudienceTags: audiences.length > 0 ? audiences : null,
          PurposesTags: purposes.length > 0 ? purposes : null,
          LocationsTags: locations.length > 0 ? locations : null,
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit('homePageItems/updateGrantsNewest', response.data);
        } else {
          store.commit('homePageItems/updateGrantsNewest', response.data);

          store.commit('grantItems/updateNewestGrants', response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async searchSchemesByDeadlineTags(
    page,
    size,
    audiences,
    purposes,
    locations
  ) {
    return await axios
      .get(API_URL + '/search/searchschemes', {
        headers: authHeader(),
        params: {
          PageSize: size,
          Page: page,
          Sort: 'Deadline',

          AudienceTags: audiences.length > 0 ? audiences : null,
          PurposesTags: purposes.length > 0 ? purposes : null,
          LocationsTags: locations.length > 0 ? locations : null,
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit('homePageItems/updateGrantsByDeadline', response.data);
        } else {
          store.commit('homePageItems/updateGrantsByDeadline', response.data);

          store.commit('grantItems/updateDeadlineGrants', response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async searchSchemesByDeadline(page, size) {
    return await axios
      .get(API_URL + '/search/searchschemes', {
        headers: authHeader(),
        params: {
          PageSize: size,
          Page: page,
          Sort: 'Deadline',
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit('homePageItems/updateGrantsByDeadline', response.data);
        } else {
          store.commit('homePageItems/updateGrantsByDeadline', response.data);

          store.commit('grantItems/updateDeadlineGrants', response.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }

  async searchSignificantSchemes(page, size) {
    return await axios
      .get(
        API_URL +
          '/search/getSchemesWithLastSignificantUpdatesBasedOnFavoriteTags',
        {
          headers: authHeader(),
          params: {
            PageSize: size,
            Page: page,
          },
        }
      )
      .then((response) => {
        if (page > 0) {
          store.commit('homePageItems/updateGrantsSignificant', response.data);
        } else {
          store.commit('homePageItems/updateGrantsSignificant', response.data);

          store.commit(
            'grantItems/updateSignificantChangesGrants',
            response.data
          );
        }
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
}

export default new GrantsService();
